import React from 'react';
import { iconSizer } from "../../../internal/icons2022/iconSizer";
import { ShapeSquareIcon16Solid } from "../../../internal/icons2022/ShapeSquareIcon/ShapeSquareIcon16Solid";
export var IndeterminateIcon = iconSizer({
  small: function small() {
    return /*#__PURE__*/React.createElement(ShapeSquareIcon16Solid, {
      size: 6
    });
  },
  medium: function medium() {
    return /*#__PURE__*/React.createElement(ShapeSquareIcon16Solid, {
      size: 8
    });
  },
  large: function large() {
    return /*#__PURE__*/React.createElement(ShapeSquareIcon16Solid, {
      size: 10
    });
  }
}, 'IndeterminateIcon');